import { REGIMES_CODE } from '../../../@types/Regime.type';

// Mapa código SAT → nombre legible. El CURP devuelve códigos crudos
// (`regimes: ["605|626"]`), así que necesitamos resolverlos a algo que el
// usuario entienda. Cubre el catálogo de regímenes de persona física y moral.
const REGIME_NAME_BY_CODE: Record<string, string> = {
	[REGIMES_CODE.GENERAL_LEY_PERSONAS_MORALES]: 'General de Ley Personas Morales',
	[REGIMES_CODE.PERSONAS_MORALES_CON_FINES_NO_LUCRATIVOS]: 'Personas Morales con Fines no Lucrativos',
	[REGIMES_CODE.SUELDOS_Y_SALARIOS]: 'Sueldos y salarios',
	[REGIMES_CODE.ARRENDAMIENTO]: 'Arrendamiento',
	'607': 'Enajenación o adquisición de bienes',
	'608': 'Demás ingresos',
	[REGIMES_CODE.RESIDENTES_EN_EXTRAJERO_SIN_ESTABLECIMIENTO_EN_MEXICO]:
		'Residentes en el extranjero',
	'611': 'Ingresos por dividendos',
	[REGIMES_CODE.ACTIVIDAD_EMPRESARIAL]: 'Actividades empresariales y profesionales',
	'614': 'Ingresos por intereses',
	'615': 'Ingresos por obtención de premios',
	'616': 'Sin obligaciones fiscales',
	'620': 'Sociedades cooperativas de producción',
	[REGIMES_CODE.RIF]: 'Incorporación Fiscal (RIF)',
	'622': 'Actividades agrícolas, ganaderas, silvícolas y pesqueras',
	'623': 'Opcional para grupos de sociedades',
	'624': 'Coordinados',
	[REGIMES_CODE.PLATAFORMAS_TECNOLOGICAS]: 'Plataformas tecnológicas',
	[REGIMES_CODE.RESICO]: 'RESICO',
	'628': 'Hidrocarburos',
	'629': 'Regímenes fiscales preferentes y empresas multinacionales',
	'630': 'Enajenación de acciones en bolsa de valores',
};

export const getRegimeName = (code: string): string => {
	const trimmed = code.trim();
	return REGIME_NAME_BY_CODE[trimmed] ?? `Régimen ${trimmed}`;
};

// El CURP entrega los regímenes como strings con códigos separados por `|`
// (ej. `["605|626"]`). Los aplanamos y deduplicamos a `{ code, name }`.
export const parseCurpRegimes = (
	regimes: string[] | undefined | null,
): { code: string; name: string }[] => {
	if (!regimes || regimes.length === 0) return [];
	const codes = regimes
		.flatMap((entry) => entry.split('|'))
		.map((code) => code.trim())
		.filter(Boolean);
	const unique = Array.from(new Set(codes));
	return unique.map((code) => ({ code, name: getRegimeName(code) }));
};
